import React from 'react';

function UserIcon() {
    return (
        <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.69314 4.33333C9.69314 5.88279 8.43705 7.13888 6.88759 7.13888C5.33812 7.13888 4.08203 5.88279 4.08203 4.33333C4.08203 2.78386 5.33812 1.52777 6.88759 1.52777C8.43705 1.52777 9.69314 2.78386 9.69314 4.33333Z" stroke="white" strokeWidth="1.5"/>
            <path d="M12.2864 14.1065C12.2896 14.1302 12.2867 14.1454 12.2833 14.1556C12.2795 14.1669 12.2725 14.1799 12.2596 14.1935C12.2335 14.2211 12.1835 14.25 12.1105 14.25H1.66601C1.59295 14.25 1.54295 14.2211 1.51684 14.1935C1.50402 14.1799 1.49694 14.1669 1.4932 14.1556C1.48979 14.1454 1.48687 14.1302 1.49005 14.1065C1.61458 13.1798 1.93711 11.7889 2.74358 10.647C3.52217 9.54453 4.77126 8.63885 6.88824 8.63885C9.00522 8.63885 10.2543 9.54453 11.0329 10.647C11.8394 11.7889 12.1619 13.1798 12.2864 14.1065Z" stroke="white" strokeWidth="1.5"/>
        </svg>

    );
}

UserIcon.propTypes = {
};

export default UserIcon;
